"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12 12a5 5 0 110-10 5 5 0 010 10zM2 20c0-4 2.001-6 6.004-6H16c4 0 6 2 6 6 0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2z' }))); };
exports.default = SvgUserFilled;
//# sourceMappingURL=UserFilled.js.map